import { DATE_FORMATTER } from '@jusbrasil-web/docview/core'
import { capitalize } from '@jusbrasil-web/shared-utils-format'

import { LawsuitProps } from './types'

const DOT = ' · '

export const getSubjects = (subjects: LawsuitProps['subjects']) =>
  subjects?.map((subject) => capitalize(subject || '')).join(DOT)

export const getDistributionDateFromLawsuit = (lawsuit: LawsuitProps) => {
  const { distributionDate } = lawsuit || {}

  if (!distributionDate) {
    return null
  }

  if (isDistributionDateValid(lawsuit)) {
    return DATE_FORMATTER.format(distributionDate)
  }

  const distributionDateFixed = distributionDate * 1000
  if (isDistributionDateValid({ ...lawsuit, distributionDate: distributionDateFixed })) {
    return DATE_FORMATTER.format(distributionDateFixed)
  }

  return null
}

const isDistributionDateValid = (lawsuit: LawsuitProps) => {
  const { cnjNumber, distributionDate } = lawsuit || {}
  const year = cnjNumber?.data?.year

  if (!year) {
    return false
  }

  const convertedDate = new Date(Number(distributionDate))
  const distributionDateYear = convertedDate.getFullYear()

  return year === distributionDateYear.toString()
}
